module.exports = __webpack_public_path__ + "static/techtogether-chicago-937326fc2dc7e0d8d4e9140002f75ab7.png";